export default () => ({
    input: {
        marginBottom: 8,
        marginTop: 16,
        width: '100%'
    }
});
